import { apiAxios } from './axios'
import base from './config'
let baseURL = base.baseURL

import clienteleApi from './apiList/clienteleApi.js'
import roleApi from './apiList/roleApi.js'
import orderApi from './apiList/orderApi.js'
import siteConfiguration from './apiList/siteConfiguration.js'
import financialApi from './apiList/financialApi.js'
import followApi from "@/api/apiList/followApi";
import problemApi from "@/api/apiList/problemApi";
import porderApi from "@/api/apiList/porderApi";
import adjustApi from "@/api/apiList/adjustApi.js";
import noticeApi from "@/api/apiList/noticeApi.js";
import signInApi from './apiList/signInApi.js'
import inspectionApi from './apiList/inspectionApi'
import warehouseApi from './apiList/warehouseApi'
import invoiceApi from './apiList/invoiceApi'
import capitalApi from './apiList/capitalApi'
import tabTotalApi from "@/api/apiList/tabTotalApi.js";
import JapaneseOffice from "@/api/apiList/JapaneseOffice.js";
import photo from "@/api/apiList/photo.js";
import productManagementApi from "@/api/apiList/productManagementApi.js";
import inSaleApi from '@/api/apiList/inSaleApi.js'
import spotCheckApi from '@/api/apiList/spotCheckApi.js'
import inventoryTransferApi from '@/api/apiList/inventoryTransferApi.js'
import costManagementApi from '@/api/apiList/costManagementApi.js'
import overseasWarehouseApi from '@/api/apiList/overseasWarehouseApi.js'
import optionServiceApi from '@/api/apiList/optionServiceApi.js'
export default {
  clienteleApi,//客户接口api
  roleApi, // 角色权限api
  orderApi, //订单列表
  siteConfiguration,//网站配置
  financialApi,//财务
  followApi,//检品
  problemApi,//问题产品
  porderApi,//配送单
  adjustApi,//出入金调整
  noticeApi,//通知
  signInApi,//签收
  inspectionApi,//商品核查
  warehouseApi,//仓库
  invoiceApi,//发票
  capitalApi,//资金
  tabTotalApi,//tab统计
  JapaneseOffice,//日本事务所
  photo,//摄影服务
  productManagementApi,// 商品管理
  inSaleApi,//售中
  spotCheckApi,//抽查
  inventoryTransferApi,//转库
  costManagementApi,//费用管理
  overseasWarehouseApi,//海外仓
  optionServiceApi,//选项服务
  //登录
  login: (data) => apiAxios('post', baseURL + '/admin.login', data),
  //获取跳转token
  getJumpToken: (data) => apiAxios('post', baseURL + '/admin.system.getJumpToken', data),
  //登录-发送验证码
  sendAdminLoginValidateCode: (data) => apiAxios('post', baseURL + '/admin.sendAdminLoginValidateCode', data),
  //登录-发送临时万能验证码
  sendUniversalCode: (data) => apiAxios('post', baseURL + '/admin.login.sendUniversalCode', data),
  //登录-发送客户端注册临时验证码
  sendClientUniversalCode: (data) => apiAxios('post', baseURL + '/admin.login.sendClientUniversalCode', data),
  //获取企业微信绑定state
  getState: (data) => apiAxios('post', baseURL + '/api/wxWork/getState', data),
  //企业微信绑定提交接口
  bindWx: (data) => apiAxios('post', baseURL + '/api/wxWork/bindWx', data),
  //企业微信登录提交接口
  wxLogin: (data) => apiAxios('post', baseURL + '/api/wxWork/wxLogin', data),



  // 权限下的各个工种账号列表(用于筛选业务采购配货等)
  getAuthWorkGroupAdmin: (data) => apiAxios('post', baseURL + '/manage.auth.getAuthWorkGroupAdmin', data),
  // 权限-同部门各工种账号列表(常用于下拉)
  getAuthWorkGroupAdminDepart: (data) => apiAxios('post', baseURL + '/manage.auth.getAuthWorkGroupAdminDepart', data),
  // 权限-同组织各工种账号列表(常用于下拉)
  getAuthWorkGroupAdminSameLevel: (data) => apiAxios('post', baseURL + '/manage.auth.getAuthWorkGroupAdminSameLevel', data),
  // 权限-部门配货员列表(常用于下拉)
  getDepartmentDistributors: (data) => apiAxios('post', baseURL + '/manage.auth.getDepartmentDistributors', data),
  // 拥有的权限
  userAuth: (data) => apiAxios('post', baseURL + '/manage.auth.userAuth', data),
  // 菜单
  menu: (data) => apiAxios('post', baseURL + '/manage.auth.menu', data),
  // 抠图
  imageMatting: (data) => apiAxios('post', 'https://laveltest.rakumart.cn/api/common/imageMatting', data),
  // 文件url转换成s可下载的文件流
  downloadFile: (data) => apiAxios('post', 'https://laveltest.rakumart.cn/api/common/downloadFile', data),
  //实时汇率（人民币&&日币）
  getExchangeRat: (data) => apiAxios('post', baseURL + '/api/common/getExchangeRat', data),
  //获取唛头数据 (打印)
  getMaitouData: (data) => apiAxios('post', baseURL + '/download.maitou.getMaitouData', data),
  //商品链接转商品ID
  goodsUrlToGoodsId: (data) => apiAxios('post', baseURL + '/api/common/goodsUrlToGoodsId', data),
  //订单导出-临时token
  orderDetailDownloadToken: (data) => apiAxios('post', baseURL + '/client/download.orderDetailDownloadToken', data),
  //谷歌翻译
  googleTranslation: (data) => apiAxios('post', baseURL + '/api/common/googleTranslation', data),
  // 转base64
  base64: (data, url) => apiAxios('get', url, data),
  // 获取1688或淘宝自建后台的token
  getAlibabaOrTaobaoUsWebToken: (data) => apiAxios('post', baseURL + '/admin.getAlibabaOrTaobaoUsWebToken', data),
  // 获取国内物流轨迹
  domesticLogisticsTracking: (data) => apiAxios('post', baseURL + '/purchase.domesticLogisticsTracking', data),
  // 控制面板-数据预览
  dashboardIndex: (data) => apiAxios('post', baseURL + '/dashboard.index', data),
  // 控制面板-效率看板可查看内容
  timeDurationMenu: (data) => apiAxios('post', baseURL + '/dashboard.timeDurationMenu', data),
  // 控制面板-效率看板
  timeDuration: (data) => apiAxios('post', baseURL + '/dashboard.timeDuration', data),
  // 异常物流统计
  abnormalParcelStatistics: (data) => apiAxios('post', baseURL + '/logistics/abnormalParcelStatistics', data),
  // 超时物流待处理数量
  overtimeStatistics: (data) => apiAxios('post', baseURL + '/logistics/overtimeStatistics', data),
  // 代取件统计
  pickUpStatistics: (data) => apiAxios('post', baseURL + '/logistics/pickUpStatistics', data),
  // 客户评价-待确认数量
  listNumUnConfirm: (data) => apiAxios('post', baseURL + '/config.evaluation.listNumUnConfirm', data),

  // 国际物流查询
  logisticsTrack: (data) => apiAxios('post', baseURL + '/api/common/logistics.logisticsTrack', data),
  // 快递100物流轨迹-查询
  getTrace: (data) => apiAxios('post', baseURL + '/api/common/expressTrace/getTrace', data),
  //chatgpt品名材质自动补全
  getHscode: (data) => apiAxios('post', baseURL + '/api/chatgpt.getHscode', data, true),
  //上传文件-前端获取STS临时token
  getUploadToken: (data) => apiAxios('post', 'https://aiapitest.rakumart.com/api/ai/stsToken', data,),
  //heic转jpeg
  heic2jpeg: (data) => apiAxios('post', baseURL + '/api/common/docker/heic2jpeg', data,),
  //图片搜索分销商品上传base64
  uploadImagePic: data => apiAxios('post', "https://api-landingpage.rakumart.cn/api/cross", data),
}